module.exports = __webpack_public_path__ + "static/media/bg.7d252bd6.png";